import { SxProps, Theme } from '@mui/material/styles';
import { brandColors, RADIUS, INPUT_HEIGHT_AUTH, INPUT_PX, TYPE } from '../../theme/appTheme';
import { brandCss } from '../../theme/brandCss';
import { catchyTextFieldSx } from '../../theme/formStyles';
import { AUTH_FONT } from './AuthCoverLayout';

/** Auth inputs — 48px height for important login fields */
export const authTextFieldSx: SxProps<Theme> = {
  ...catchyTextFieldSx,
  '& .MuiInputLabel-root': {
    fontFamily: AUTH_FONT,
    fontWeight: TYPE.fieldLabel.fontWeight,
    fontSize: TYPE.fieldLabel.fontSize,
    lineHeight: TYPE.fieldLabel.lineHeight,
    color: brandColors.textDark,
    mb: '6px',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: `${RADIUS}px`,
    bgcolor: '#fff',
    fontFamily: AUTH_FONT,
    fontSize: TYPE.fieldInput.fontSize,
    fontWeight: TYPE.fieldInput.fontWeight,
    height: INPUT_HEIGHT_AUTH,
    minHeight: INPUT_HEIGHT_AUTH,
    boxSizing: 'border-box',
    transition: 'box-shadow 0.18s ease, border-color 0.18s ease',
    '& input, & .MuiSelect-select': {
      fontFamily: AUTH_FONT,
      fontSize: TYPE.fieldInput.fontSize,
      fontWeight: TYPE.fieldInput.fontWeight,
      lineHeight: TYPE.fieldInput.lineHeight,
      py: 0,
      height: INPUT_HEIGHT_AUTH,
      boxSizing: 'border-box',
      px: `${INPUT_PX}px`,
      '&::placeholder': {
        fontSize: TYPE.fieldInput.fontSize,
        fontWeight: 400,
        opacity: 0.75,
      },
    },
    '& fieldset': {
      borderColor: '#e2e8f0',
      borderWidth: 1.5,
    },
    '&:hover': {
      bgcolor: '#fafafa',
      '& fieldset': { borderColor: brandCss.primaryLight },
    },
    '&.Mui-focused': {
      bgcolor: '#fff',
      boxShadow: `0 0 0 3px ${brandCss.primary}18`,
      '& fieldset': {
        borderColor: brandCss.primary,
        borderWidth: 1.75,
      },
    },
  },
  '& .MuiFormHelperText-root': {
    fontFamily: AUTH_FONT,
    fontSize: TYPE.helper.fontSize,
    lineHeight: TYPE.helper.lineHeight,
    mt: 0.75,
  },
};

export const authSectionTitleSx: SxProps<Theme> = {
  color: brandCss.primaryDark,
  mb: 1.75,
  mt: 0.5,
  fontWeight: 600,
  fontSize: TYPE.helper.fontSize,
  lineHeight: TYPE.helper.lineHeight,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  fontFamily: AUTH_FONT,
};
